import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

const date = new Date();
const day = String(date.getDate()).padStart(2, "0");
const month = String(date.getMonth() + 1).padStart(2, "0");
const year = date.getFullYear();

export const COLUMNS_DATA = ({
  deleteRow,
  editDoctors,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  viewIPRates,
  addIPRates,
  viewTestCharges,
  addTestCharges,
  handleActivateDoctor,
  data,
}) => {
  const columns = [
    {
      Header: "S.No",
      accessor: "_index",
      disableSortBy: true,
    },
    {
      Header: "Id",
      accessor: "id",
      disableSortBy: true,
    },
    {
      Header: "Doctor Name",
      accessor: "doctor_name",
      disableSortBy: true,
    },
    {
      Header: "Degree",
      accessor: "doctor_degree_obj.degree_name",
      disableSortBy: true,
    },
    {
      Header: "Specialization",
      accessor: "specialization_obj.specialization",
      disableSortBy: true,
    },
    {
      Header: "Hospital Name",
      accessor: "clinic_name",
      disableSortBy: true,
    },
    {
      Header: "Clinic Name",
      accessor: "hospital_name",
      disableSortBy: true,
    },
    {
      Header: "Area Name",
      accessor: "area_name",
      disableSortBy: true,
    },
    {
      Header: "Clinic Phone Number",
      accessor: "clinic_phone",
      disableSortBy: true,
    },
    {
      Header: "Email ID",
      accessor: "email",
      disableSortBy: true,
    },
    {
      Header: "Resident Phone",
      accessor: "phone_res",
      disableSortBy: true,
    },
    {
      Header: "Address",
      accessor: "address",
      disableSortBy: true,
    },
    {
      Header: "Date of Birth",
      accessor: "doctor_dob",
      disableSortBy: true,
    },
    {
      Header: "Marriage Anniversary",
      accessor: "doctor_marriage_anniversary",
      disableSortBy: true,
    },
    {
      Header: "Clinic Address",
      accessor: "clinic_address",
      disableSortBy: true,
    },
    {
      Header: "Hospital Address",
      accessor: "hospital_address",
      disableSortBy: true,
    },
    {
      Header: "Hospital Phone Number",
      accessor: "hospital_phone",
      disableSortBy: true,
    },
    {
      Header: "Mobile Number",
      accessor: "mobile",
      disableSortBy: true,
    },
    {
      Header: "Remark",
      accessor: "remark",
      disableSortBy: true,
    },
    {
      Header: "Username",
      accessor: "doctor_username",
      disableSortBy: true,
    },
    {
      Header: "Tagged",
      accessor: "tagged",
      disableSortBy: true,
      Cell: ({ cell }) => {
        const originalData = cell.row.original;
        return originalData.urgent === true ? "Yes" : "No";
      },
    },
    {
      Header: "Discount Approved",
      accessor: "discount_approved",
      disableSortBy: true,
      Cell: ({ cell }) => {
        const originalData = cell.row.original;
        return originalData.urgent === true ? "Yes" : "No";
      },
    },
    {
      Header: "Zone",
      accessor: "zone_name",
      disableSortBy: true,
    },
    {
      Header: "",
      accessor: "ids",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <>
            <button
              disabled={!filters.is_active}
              className={classNames("btn dropdown-toggle", {
                "btn-primary": filters.is_active,
                "btn-secondary": !filters.is_active,
              })}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              More...
            </button>
            <ul className="dropdown-menu">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => editDoctors(cell.row.original)}
                >
                  Edit
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() => viewIPRates(cell.row.original)}
                >
                  View IP Rates
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() => addIPRates(cell.row.original)}
                >
                  Add IP Rates
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() => viewTestCharges(cell.row.original)}
                >
                  View Test Charges
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item"
                  onClick={() => addTestCharges(cell.row.original)}
                >
                  Add Test Charges
                </button>
              </li>

              {isSuperFranchise != 1 &&
                isFranchiseEmployee != 1 &&
                isSubFranchise != 1 && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => deleteRow(cell.row.original)}
                    >
                      Delete
                    </button>
                  </li>
                )}
            </ul>
          </>
        );
      },
    },
  ];
  const hasInactive = data?.some((row) => !row.is_active);

  if (hasInactive) {
    const actionColumn = {
      Header: "Action",
      disableSortBy: true,
      Cell: ({ row }) => (
        <button
          onClick={() => handleActivateDoctor(row.original.id)}
          className="btn btn-primary"
        >
          Activate
        </button>
      ),
    };

    columns.splice(4, 0, actionColumn);
  }

  return columns;
};

export const OPTIONS = [
  { key: "doctor_name", value: "Doctor Name" },
  { key: "clinic_name", value: "Clinic Name" },
  { key: "hospital_name", value: "Hospital Name" },
  { key: "area_name", value: "Area Name" },
  { key: "clinic_phone", value: "Clinic Phone" },
  { key: "email", value: "Email" },
  { key: "phone_res", value: "Resident Phone" },
  { key: "address", value: "Address" },
  { key: "clinic_address", value: "Clinic Address" },
  { key: "hospital_address", value: "Hospital Address" },
  { key: "hospital_phone", value: "Hospital Phone" },
  { key: "mobile", value: "Mobile" },
  { key: "doctor_username", value: "Username" },
];
export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

const IS_WORKING_OPTIONS = [
  { key: true, value: "Yes" },
  { key: false, value: "No" },
];
export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];

export const DOCTOR_FORM_CONFIG = (
  rowData,
  loggedInEmployeeCode = Number(localStorage.getItem("employee_code_id"))
) => {
  return [
    {
      label: "Doctor Name",
      type: "input-text",
      name: "doctor_name",
      defaultValue: rowData?.doctor_name,
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Doctor's Degree",
      type: "select",
      name: "degree_name",
      defaultValue: rowData?.doctor_degree_id,
      options: [],
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Doctor's Specialization",
      type: "select",
      name: "specialization_name",
      defaultValue: rowData?.specialization_id,
      options: [],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Doctor ID",
      type: "input-text",
      name: "doctor_id",
      defaultValue: rowData?.doctor_id,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Area Name",
      type: "input-text",
      name: "area_name",
      defaultValue: rowData?.area_name,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Clinic Name",
      type: "input-text",
      name: "clinic_name",
      defaultValue: rowData?.clinic_name,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Hospital Name",
      type: "input-text",
      name: "hospital_name",
      defaultValue: rowData?.hospital_name,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Clinic Phone",
      type: "input-text",
      name: "clinic_phone",
      defaultValue: rowData?.clinic_phone,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Email ID",
      type: "email",
      name: "email",
      defaultValue: rowData?.email,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Resident Phone Number",
      type: "input-text",
      name: "phone_res",
      defaultValue: rowData?.phone_res,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Address",
      type: "input-text",
      name: "address",
      defaultValue: rowData?.address,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Date Of Birth",
      type: "input-date",
      name: "doctor_dob",
      defaultValue: rowData?.doctor_dob || `${year}-${month}-${day}`,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Marriage Anniversary",
      type: "input-date",
      name: "doctor_marriage_anniversary",
      defaultValue:
        rowData?.doctor_marriage_anniversary || `${year}-${month}-${day}`,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Clinic Address",
      type: "input-text",
      name: "clinic_address",
      defaultValue: rowData?.clinic_address,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Hospital Address",
      type: "input-text",
      name: "hospital_address",
      defaultValue: rowData?.hospital_address,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Hospital Phone Number",
      type: "input-text",
      name: "hospital_phone",
      defaultValue: rowData?.hospital_phone,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Mobile Number",
      type: "input-text",
      name: "mobile",
      defaultValue: rowData?.mobile,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Doctor's Remarks",
      type: "input-text",
      name: "remark",
      defaultValue: rowData?.remark,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Username",
      type: "input-text",
      name: "doctor_username",
      defaultValue: rowData?.doctor_username,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Password",
      type: "input-password",
      name: "password_md5",
      defaultValue: rowData?.password_md5,
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Tagged",
      type: "select",
      name: "tagged",
      defaultValue: rowData?.tagged,
      options: [
        { key: true, value: true, label: "Yes" },
        { key: false, value: false, label: "No" },
      ],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Discount Approved",
      type: "select",
      name: "discount_approved",
      defaultValue: rowData?.discount_approved,
      options: [
        { key: true, value: true, label: "Yes" },
        { key: false, value: false, label: "No" },
      ],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "IP Calculation Method",
      type: "select",
      name: "ip_calculation_method",
      options: [
        { label: "On MRP", value: "ON_MRP" },
        { label: "After Discount", value: "AFTER_DISCOUNT" },
      ],
      defaultValue: rowData?.ip_calculation_method || "ON_MRP",
      validations: {
        required: true,
      },
    },
    {
      label: "Zone",
      type: "select",
      name: "zone_id",
      defaultValue: rowData?.zone_id,
      options: [],
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Doctor Type",
      type: "select",
      name: "doctor_type",
      defaultValue: rowData?.doctor_type || "EXTERNAL",
      options: [
        { key: "internal", value: "INTERNAL", label: "Internal" },
        { key: "external", value: "EXTERNAL", label: "External" },
      ],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
  ];
};

export const COLUMNS_DATA_IP_RATES = ({
  deleteRow,
  editDoctors,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  viewIPRates,
  editInvestigationComment,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Department Name",
    accessor: "lab_department_obj.department",
    disableSortBy: true,
  },
  {
    Header: "Package Name",
    accessor: "package_id.package_name",
    disableSortBy: true,
  },
  {
    Header: "IP Percentage",
    accessor: "ip_percentage",
    disableSortBy: true,
  },
  // {
  //   Header: "",
  //   accessor: "ids",
  //   disableSortBy: true,
  //   Cell: ({ cell }) => {
  //     return (
  //       <>
  //         <button
  //           disabled={!filters.is_active}
  //           className={classNames("btn dropdown-toggle", {
  //             "btn-primary": filters.is_active,
  //             "btn-secondary": !filters.is_active,
  //           })}
  //           type="button"
  //           data-bs-toggle="dropdown"
  //           aria-expanded="false"
  //         >
  //           More...
  //         </button>
  //         <ul className="dropdown-menu">
  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Edit
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => viewIPRates(cell.row.original)}
  //             >
  //               View IP Rates
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Add IP Rates
  //             </button>
  //           </li>

  //           {isSuperFranchise != 1 &&
  //             isFranchiseEmployee != 1 &&
  //             isSubFranchise != 1 && (
  //               <li>
  //                 <button
  //                   className="dropdown-item"
  //                   onClick={() => deleteRow(cell.row.original)}
  //                 >
  //                   Delete
  //                 </button>
  //               </li>
  //             )}
  //         </ul>
  //       </>
  //     );
  //   },
  // },
  {
    Header: "",
    accessor: "ids",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => editInvestigationComment(cell.row.original)}
              >
                Edit
              </button>
            </li>
            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRow(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
          </ul>
        </>
      );
    },
  },
];

export const COLUMNS_DATA_IP_RATES_VIEW = ({
  deleteRow,
  editDoctors,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  viewIPRates,
  editInvestigationComment,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Department Name",
    accessor: "lab_department_obj.department",
    disableSortBy: true,
  },
  {
    Header: "Package Name",
    accessor: "package_obj.package_name",
    disableSortBy: true,
  },
  {
    Header: "Investigation Name",
    accessor: "investigation_obj.investigation_name",
    disableSortBy: true,
  },
  {
    Header: "IP Percentage",
    accessor: "ip_percentage",
    disableSortBy: true,
  },
  // {
  //   Header: "",
  //   accessor: "ids",
  //   disableSortBy: true,
  //   Cell: ({ cell }) => {
  //     return (
  //       <>
  //         <button
  //           disabled={!filters.is_active}
  //           className={classNames("btn dropdown-toggle", {
  //             "btn-primary": filters.is_active,
  //             "btn-secondary": !filters.is_active,
  //           })}
  //           type="button"
  //           data-bs-toggle="dropdown"
  //           aria-expanded="false"
  //         >
  //           More...
  //         </button>
  //         <ul className="dropdown-menu">
  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Edit
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => viewIPRates(cell.row.original)}
  //             >
  //               View IP Rates
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Add IP Rates
  //             </button>
  //           </li>

  //           {isSuperFranchise != 1 &&
  //             isFranchiseEmployee != 1 &&
  //             isSubFranchise != 1 && (
  //               <li>
  //                 <button
  //                   className="dropdown-item"
  //                   onClick={() => deleteRow(cell.row.original)}
  //                 >
  //                   Delete
  //                 </button>
  //               </li>
  //             )}
  //         </ul>
  //       </>
  //     );
  //   },
  // },
];

export const IP_RATES_FORM_CONFIG = (rowData) => [
  {
    label: "Lab Department",
    type: "select",
    name: "lab_department",
    defaultValue: rowData?.lab_department_obj?.id || "",
    options: [],
    validations: {
      required: false,
    },
  },
  {
    label: "Package",
    type: "select",
    name: "package_id",
    defaultValue: rowData?.package_id?.id || "",
    options: [],
    validations: {
      required: false,
    },
  },
  // {
  //   label: "Doctor",
  //   type: "select",
  //   name: "refer_doctor_name",
  //   defaultValue: rowData?.doctor_id || "",
  //   options: [],
  //   validations: {
  //     required: true,
  //   },
  // },
  {
    label: "Investigation",
    type: "select",
    name: "investigation_name",
    defaultValue: rowData?.investigation_id?.id || "",
    options: [],
    validations: {
      required: false,
    },
  },
  {
    label: "IP Percentage",
    type: "input-number",
    name: "ip_percentage",
    defaultValue: rowData?.ip_percentage || "",
    validations: {
      required: true,
    },
  },
];

export const COLUMNS_DATA_TEST_CHARGES_VIEW = ({
  deleteRow,
  editDoctors,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  viewIPRates,
  editInvestigationComment,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Doctor",
    accessor: "doctor_obj.doctor_name",
    disableSortBy: true,
  },
  {
    Header: "Department Name",
    accessor: "investigation_onj.investigation_name",
    disableSortBy: true,
  },
  {
    Header: "Charges Percentage",
    accessor: "charge_percentage",
    disableSortBy: true,
  },
  {
    Header: "Charges Amount",
    accessor: "charge_amount",
    disableSortBy: true,
  },
  {
    Header: "",
    accessor: "ids",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => editInvestigationComment(cell.row.original)}
              >
                Edit
              </button>
            </li>
            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRow(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
          </ul>
        </>
      );
    },
  },
  // {
  //   Header: "",
  //   accessor: "ids",
  //   disableSortBy: true,
  //   Cell: ({ cell }) => {
  //     return (
  //       <>
  //         <button
  //           disabled={!filters.is_active}
  //           className={classNames("btn dropdown-toggle", {
  //             "btn-primary": filters.is_active,
  //             "btn-secondary": !filters.is_active,
  //           })}
  //           type="button"
  //           data-bs-toggle="dropdown"
  //           aria-expanded="false"
  //         >
  //           More...
  //         </button>
  //         <ul className="dropdown-menu">
  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Edit
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => viewIPRates(cell.row.original)}
  //             >
  //               View IP Rates
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Add IP Rates
  //             </button>
  //           </li>

  //           {isSuperFranchise != 1 &&
  //             isFranchiseEmployee != 1 &&
  //             isSubFranchise != 1 && (
  //               <li>
  //                 <button
  //                   className="dropdown-item"
  //                   onClick={() => deleteRow(cell.row.original)}
  //                 >
  //                   Delete
  //                 </button>
  //               </li>
  //             )}
  //         </ul>
  //       </>
  //     );
  //   },
  // },
];

export const TEST_CHARGES_FORM_CONFIG = (
  rowData,
  chargeType = rowData?.charge_amount && !rowData?.charge_percentage
    ? "amount"
    : "percentage"
) => [
  // {
  //   label: "Doctor",
  //   type: "select",
  //   name: "refer_doctor_name",
  //   defaultValue: rowData?.doctor_id || "",
  //   options: [],
  //   validations: {
  //     required: false,
  //   },
  // },
  {
    label: "Investigation",
    type: "select",
    name: "investigation_name",
    defaultValue: rowData?.investigation_id?.id || "",
    options: [],
    validations: {
      required: true,
    },
  },
  ...(chargeType === "percentage"
    ? [
        {
          label: "Charges Percentage",
          type: "input-number",
          name: "charge_percentage",
          defaultValue: rowData?.charge_percentage ?? "",
          validations: {
            required: true,
            max: 100,
          },
          placeholder: "Enter percentage (0-100)",
        },
      ]
    : [
        {
          label: "Charges Amount",
          type: "input-number",
          name: "charge_amount",
          defaultValue: rowData?.charge_amount ?? "",
          validations: {
            required: true,
          },
          placeholder: "Enter amount (₹)",
        },
      ]),
];

export const FILTER_DEFINITIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
